"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var formik_1 = require("formik");
var asg_1 = require("@alinta-digital/asg");
var PaymentDetails_1 = require("../../view/PaymentDetails");
var EmailAddress = function () {
    return (react_1.default.createElement(asg_1.Box, { margin: { top: 'medium' }, width: "100%", maxWidth: "704px" },
        react_1.default.createElement(formik_1.Field, { name: PaymentDetails_1.SECTION_KEY + ".emailAddress", id: PaymentDetails_1.SECTION_KEY + ".emailAddress", "data-testid": PaymentDetails_1.SECTION_KEY + "-emailAddress", ariaRequired: true, type: "email", label: "Email receipt to", placeholder: "Email address", component: asg_1.FormTextInput })));
};
exports.default = EmailAddress;
//# sourceMappingURL=EmailAddress.js.map